import { Container, Table } from "../../../components";
import { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FormActa from "../../../views/Forms/FormActa";
import { useFormActaStore } from "../../../store/formActaStore";

import { handlerMisActas } from "../../../handlers/actas.handler";

import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useDataUserStore } from "../../../store/dataUserStore";
import AddIcon from "../../../components/svgs/AddIcon";
import { NavigateBeforeOutlined } from "@mui/icons-material";
import { UserContext } from "../../../context";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Link, useLocation } from "react-router-dom";
import useWindowSize from "../../../hooks/useWindowSize";
import { getEdad } from "../../../utils/getEdad";
import { cargaDatos } from "../../Public/Actas/handlers";
import { tableData } from "../../Public/Actas/tableData";
import { useInspectorStore } from "../../../store/inspectorStore";
import {
  handlerGetActaInspector,
  handlerInspectorActas,
} from "../../../handlers/inspector.handler";
import ModalActaInspector from "./components/ModalActaInspector";
import ModalConstatacion from "./components/ModalConstatacion";
import ModalCancelarActa from "./components/ModalCancelarActa";

const ESTADOS_ACTAS_INSPECTOR = [
  { label: "Pendiente", value: 5, color: "#f59e0b" },
  { label: "Aprobadas", value: 2, color: "#16a34a" },
  { label: "No aprobadas", value: 3, color: "#dc2626" },
];

const ActasInspector = () => {
  const size = useWindowSize();
  const { width } = size;

  const path = useLocation().pathname;
  const { actas, acta, refetch, setRefetch } = useInspectorStore();

  const { loads, modals, handlerModal } = useGeneralAppStore();
  const { misActas } = useDataUserStore();
  const [paso, setPaso] = useState();
  const [estadoId, setEstadoId] = useState(5);

  const { actions: ua } = useContext(UserContext);
  const perfil = ua.getPerfil();

  // useEffect(() => {
  //     if (!tipos || !barrios) {
  //         cargaDatos(setTipos, setBarrios, setLoading);
  //     }
  //     handlerMisActas();
  // }, []);
  useEffect(() => {
    handlerInspectorActas(estadoId);
  }, [estadoId]);

  useEffect(() => {
    if (refetch) {
      handlerInspectorActas(estadoId);
      setRefetch(false);
    }
  }, [estadoId, refetch]);

  // useEffect(() => {
  //     if (defaultValues) {
  //         setPaso(defaultValues?.ultimo_paso);
  //     } else {
  //         setPaso(null);
  //     }
  // }, [defaultValues]);

  // useEffect(() => {
  //     return () => {
  //         setDefaultValues(null);
  //         setPaso(null);
  //         setFormActive(false);
  //     };
  // }, []);

  return (
    <Container tituloApp={"ARBOLADO"} titulo={"Solicitudes inspector"} size={"md"} linkBack={"/"}>
      <div
        className="position-relative d-flex " /* style={{ minHeight:"80vh" }} */ /* style={{ minHeight: "60vh" }} */
      >
        <motion.div
          key="table"
          className="w-100 co-12 "
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          style={{ overflow: "hidden", minWidth: "100%", minHeight: "455px" }}
        >
          <div className="d-flex gap-2 flex-wrap mb-3">
            {ESTADOS_ACTAS_INSPECTOR.map((estado) => {
              const active = estadoId === estado.value;

              return (
                <button
                  key={estado.value}
                  type="button"
                  className="btn btn-sm fw-semibold"
                  onClick={() => setEstadoId(estado.value)}
                  style={{
                    backgroundColor: active ? estado.color : "transparent",
                    borderColor: estado.color,
                    color: active ? "#fff" : estado.color,
                  }}
                >
                  {estado.label}
                </button>
              );
            })}
          </div>
          <Table
            height={"65vh"}
            rowHeight={80}
            rowClick={(params) => {
              if (path == "/inspecciones_solicitudes") {
                handlerGetActaInspector(params.row.id);
              }
            }}
            // height={"435px"}
            loading={["actas_inspector", "acta_inspector"].some((item) => loads.includes(item))}
            data={tableData(actas, width, path)}
          />
        </motion.div>

        {modals.includes("modal_solicitud_inspector") && (
          <ModalActaInspector
            show={modals.includes("modal_solicitud_inspector")}
            onHide={() => {
              handlerModal({ modal: false, modalName: "modal_solicitud_inspector" });
            }}
          />
        )}
        {modals.includes("cancelar_acta") && <ModalCancelarActa actaId={acta.id} />}
        {modals.includes("modal_constatacion") && <ModalConstatacion actaId={acta.id} />}
        {/* {formActive && <FormActa />} */}
      </div>
    </Container>
  );
};
export default ActasInspector;
